<template>
  <landing-page-best-music />
</template>

<script>
import LandingPageBestMusic from '@/views/LandingPageBestMusic.vue'

export default {
  name: 'HomePage',

  components: {
    LandingPageBestMusic
  }
}
</script>
